var _path;
const _excluded = ["title", "titleId"],
  _excluded2 = ["title", "titleId"],
  _excluded3 = ["className", "color", "size", "pointer"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
import { hooks } from '@approvalmax/utils';
const SVG = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M2.338 8.23h14.324c.645 0 1.169.552 1.169 1.232v11.076c0 .68-.524 1.231-1.17 1.231H2.338c-.645 0-1.169-.55-1.169-1.23V9.461c0-.68.524-1.231 1.17-1.231ZM0 9.463C0 8.102 1.047 7 2.338 7h14.324C17.953 7 19 8.102 19 9.462v11.076C19 21.898 17.953 23 16.662 23H2.338C1.047 23 0 21.898 0 20.538zM16.15 11c0 .552-.425 1-.95 1s-.95-.448-.95-1 .425-1 .95-1 .95.448.95 1m-5.211 3.923a1.13 1.13 0 0 1 1.653 0l4.337 4.565c.228.24.228.63 0 .87a.564.564 0 0 1-.827 0l-4.337-4.565-4.336 4.565a.564.564 0 0 1-.827 0 .64.64 0 0 1 0-.87zm-6.577.77a1.13 1.13 0 0 1 1.653 0l1.487 1.564c.228.24.228.63 0 .87a.564.564 0 0 1-.827 0L5.19 16.564l-2.437 2.565a.564.564 0 0 1-.827 0 .64.64 0 0 1 0-.87l2.437-2.566ZM20.498 1.5a.5.5 0 0 0-1 0v1.998H17.5a.5.5 0 0 0 0 1h1.998v1.999a.5.5 0 1 0 1 0V4.498h1.999a.5.5 0 0 0 0-1h-1.998z",
    clipRule: "evenodd"
  })));
});
const SvgAddFile = (_ref2, ref) => {
  let {
      title,
      titleId
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  const {
      className = '',
      color,
      size,
      pointer
    } = props,
    restProps = _objectWithoutProperties(props, _excluded3);
  const isClient = hooks.useOnlyClientRendering();
  const colorClassNameMod = color ? 'am-icon_color-' + color : '';
  const sizeClassNameMod = size ? 'am-icon_size-' + size : '';
  const poinerClassNameMod = pointer ? 'am-icon_pointer' : '';
  const classNames = [className, 'am-icon', colorClassNameMod, sizeClassNameMod, poinerClassNameMod].join(' ');
  if (!isClient) return null;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    className: classNames
  }, restProps));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAddFile);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBmaWxsPSJjdXJyZW50Q29sb3IiIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTTIuMzM4IDguMjNoMTQuMzI0Yy42NDUgMCAxLjE2OS41NTIgMS4xNjkgMS4yMzJ2MTEuMDc2YzAgLjY4LS41MjQgMS4yMzEtMS4xNyAxLjIzMUgyLjMzOGMtLjY0NSAwLTEuMTY5LS41NS0xLjE2OS0xLjIzVjkuNDYxYzAtLjY4LjUyNC0xLjIzMSAxLjE3LTEuMjMxWk0wIDkuNDYzQzAgOC4xMDIgMS4wNDcgNyAyLjMzOCA3aDE0LjMyNEMxNy45NTMgNyAxOSA4LjEwMiAxOSA5LjQ2MnYxMS4wNzZDMTkgMjEuODk4IDE3Ljk1MyAyMyAxNi42NjIgMjNIMi4zMzhDMS4wNDcgMjMgMCAyMS44OTggMCAyMC41MzhWOS40NjJaTTE2LjE1IDExYzAgLjU1Mi0uNDI1IDEtLjk1IDEtLjUyNSAwLS45NS0uNDQ4LS45NS0xcy40MjUtMSAuOTUtMWMuNTI1IDAgLjk1LjQ0OC45NSAxWm0tNS4yMTEgMy45MjNhMS4xMjggMS4xMjggMCAwIDEgMS42NTMgMGw0LjMzNyA0LjU2NWMuMjI4LjI0LjIyOC42MyAwIC44N2EuNTY0LjU2NCAwIDAgMS0uODI3IDBsLTQuMzM3LTQuNTY1LTQuMzM2IDQuNTY1YS41NjQuNTY0IDAgMCAxLS44MjcgMCAuNjM5LjYzOSAwIDAgMSAwLS44N2w0LjMzNy00LjU2NVptLTYuNTc3Ljc3YTEuMTI4IDEuMTI4IDAgMCAxIDEuNjUzIDBsMS40ODcgMS41NjRjLjIyOC4yNC4yMjguNjMgMCAuODdhLjU2NC41NjQgMCAwIDEtLjgyNyAwTDUuMTkgMTYuNTY0bC0yLjQzNyAyLjU2NWEuNTY0LjU2NCAwIDAgMS0uODI3IDAgLjYzOS42MzkgMCAwIDEgMC0uODdsMi40MzctMi41NjZaTTIwLjQ5OCAxLjVhLjUuNSAwIDAgMC0xIDB2MS45OThIMTcuNWEuNS41IDAgMCAwIDAgMWgxLjk5OHYxLjk5OWEuNS41IDAgMSAwIDEgMFY0LjQ5OGgxLjk5OWEuNS41IDAgMCAwIDAtMWgtMS45OThWMS41WiIgY2xpcC1ydWxlPSJldmVub2RkIi8+PC9zdmc+Cg==";